import NotificationAddOutlinedIcon from '@mui/icons-material/NotificationAddOutlined';
import { IconButton } from '@mui/material';
import { ICellRendererParams } from 'ag-grid-community';
import { FC, useCallback } from 'react';
import { IKPIRequestDataModel } from '../../../../../data-models/kpi-requests.data-model';
import { KpiAction } from '../../../../../services/state/KPI/KPIRequestsStateJ';
import { useRequestActions } from '../KPIRequestResponse/hooks/useKPIRequestResponseActions';
import { MoreRequestOptionsButton } from './DeleteRequest';
import { ActionIndicatorSlot, RequestActionsRow } from './RequestActionsRow';

export const SendReminderTitle = 'Send Reminder';

export const SentRequestActions: FC<ICellRendererParams<IKPIRequestDataModel>> = (params) => {
  const { data, node } = params;
  const { onSelectAction } = useRequestActions();

  const handleSelectAction = useCallback(
    (action: KpiAction) => {
      onSelectAction(data!, action);
    },
    [data, onSelectAction]
  );

  if (!data || !data.respondent?.length || node?.group) {
    return null;
  }

  return (
    <RequestActionsRow>
      <IconButton
        color='secondary'
        size='medium'
        onClick={() => handleSelectAction(KpiAction.sendReminder)}
        title={SendReminderTitle}
      >
        <NotificationAddOutlinedIcon />
      </IconButton>
      <ActionIndicatorSlot />
      <MoreRequestOptionsButton request={data} />
    </RequestActionsRow>
  );
};
